import type { Appointment, Store } from '@geely/shared';
import {
  Badge,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@geely/ui';
import { getStatusLabel, getStatusColor } from '@/lib/utils';
import { AppointmentInfoSection } from './AppointmentInfoSection';
import { CustomerDataSection } from './CustomerDataSection';
import { AppointmentActions } from './AppointmentActions';

interface AppointmentDetailsProps {
  appointment: Appointment;
  store: Store;
  onCancel: () => void;
  onReschedule: () => void;
}

export function AppointmentDetails({ appointment, store, onCancel, onReschedule }: AppointmentDetailsProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-start justify-between">
          <CardTitle>Detalhes do Agendamento</CardTitle>
          <Badge variant="outline" className={getStatusColor(appointment.status)}>
            {getStatusLabel(appointment.status)}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <AppointmentInfoSection
          store={store}
          date={appointment.date}
          time={appointment.time}
        />

        <CustomerDataSection
          customerName={appointment.customerName}
          vehicleMileage={appointment.vehicleMileage}
          modelName={(appointment as any).model?.name}
          versionName={(appointment as any).version?.name}
        />

        <div className="border-t pt-4 space-y-3">
          {/* Confirmação de Presença */}
          <div>
            <p className="text-sm font-medium text-gray-700 mb-1">Confirmação de Presença</p>
            {appointment.confirmedAt ? (
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                  ✓ Confirmado
                </Badge>
                <span className="text-xs text-gray-500">
                  em {new Date(appointment.confirmedAt).toLocaleString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </span>
              </div>
            ) : (
              <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
                ⏱ Aguardando confirmação
              </Badge>
            )}
          </div>

          <p className="text-sm text-gray-500">
            ID do Agendamento: <span className="font-mono font-medium">{appointment.id}</span>
          </p>
        </div>

        <AppointmentActions
          status={appointment.status}
          onReschedule={onReschedule}
          onCancel={onCancel}
        />
      </CardContent>
    </Card>
  );
}
